<div class="er-receipt">
    <div class="er-receipt-head">
        <img [src]="ymLogoPng" class="er-receipt-logo" alt="logo">
        <h6 class="er-receipt-msg">{{data.message}}</h6>
        <div class="er-receipt-time">{{data.object.requestTransactionTime}}</div>
    </div>

    <div class="er-receipt-hero">
        <img src="https://images.vartulz.com/aepsimg.png" class="er-receipt-service-ico" alt="">
        <label class="er-receipt-amount" *ngIf="objectData.amount>0">{{objectData.amount | erInr}}</label>
    </div>

    <div class="row er-receipt-grid">
        <div class="col-md-6">
            <small class="er-receipt-label">Customer's bank</small>
            <label class="er-receipt-value">{{objectData.aepsBankName || objectData.cashwithdrawlDetails.bankName}}</label>

            <small class="er-receipt-label">Transaction ID</small>
            <label class="er-receipt-value er-receipt-mono">{{objectData.fpTransactionId || objectData.cashwithdrawlDetails.fpTransactionId}}</label>

            <small class="er-receipt-label">Download receipt</small>
            <div class="er-receipt-actions">
                <img *ngIf="objectData && objectData.cashwithdrawlDetails && objectData.cashwithdrawlDetails.transactionType=='CW'" src="../../../assets/images/file_pdf_download_icon.svg" (click)="downloadPdf(objectData.transactionReference,'')" class="er-receipt-dl">
                <img *ngIf="objectData && objectData.cashwithdrawlDetails && objectData.cashwithdrawlDetails.transactionType=='M'" src="../../../assets/images/file_pdf_download_icon.svg" (click)="downloadPdf(objectData.transactionReference,'')" class="er-receipt-dl">
                <img *ngIf="objectData && objectData.transactionType=='MS'" src="../../../assets/images/file_pdf_download_icon.svg" (click)="downloadPdfMS(data.receiptURl,'')" class="er-receipt-dl">
                <img *ngIf="objectData && objectData.cashwithdrawlDetails.transactionType=='MS'" src="../../../assets/images/file_pdf_download_icon.svg" (click)="downloadPdfMS(data.receiptURl || objectData.receiptUrl)" class="er-receipt-dl">

                <img *ngIf="objectData && objectData.transactionType=='BE'" src="../../../assets/images/file_pdf_download_icon.svg" (click)="downloadPdf(objectData.ymTransactionReferance,'')" class="er-receipt-dl">
                <img *ngIf="objectData && objectData.cashwithdrawlDetails && objectData.cashwithdrawlDetails.transactionType=='BE'" src="../../../assets/images/file_pdf_download_icon.svg" (click)="downloadPdf(objectData.transactionReference,'')" class="er-receipt-dl">
            </div>
        </div>
        <div class="col-md-6">
            <small class="er-receipt-label">Account balance</small>
            <label class="er-receipt-value">{{(objectData.balanceAmount || objectData.cashwithdrawlDetails.balanceAmount) | erInr}}</label>

            <small class="er-receipt-label">Aadhaar number</small>
            <label class="er-receipt-value er-receipt-mono">{{objectData.aadharNumber || objectData.cashwithdrawlDetails.aadharNumber}}</label>

            <small class="er-receipt-label">Share receipt</small>
            <div class="er-receipt-actions">
                <share-button *ngIf="objectData && objectData.cashwithdrawlDetails && objectData.cashwithdrawlDetails.transactionType=='CW'" button="whatsapp" [showText]="true" (click)="downloadPdf(objectData.transactionReference,'whatsapp')" [url]="pdfUrlWhatsapp" [title]="'AePS Transaction Receipt'" [description]="'Receipt'" [tags]="'AePS'">
                </share-button>
                <share-button *ngIf="objectData && objectData.cashwithdrawlDetails && objectData.cashwithdrawlDetails.transactionType=='M'" button="whatsapp" [showText]="true" (click)="downloadPdf(objectData.transactionReference,'whatsapp')" [url]="pdfUrlWhatsapp" [title]="'Aadhaar Pay Transaction Receipt'" [description]="'Receipt'" [tags]="'AePS'">
                </share-button>

                <share-button *ngIf="objectData && objectData.transactionType=='BE'" button="whatsapp" [showText]="true" (click)="downloadPdf(objectData.ymTransactionReferance,'whatsapp')" [url]="pdfUrlWhatsapp" [title]="'AePS Transaction Receipt'" [description]="'Receipt'" [tags]="'AePS'">
                </share-button>
                <share-button *ngIf="objectData && objectData.cashwithdrawlDetails && objectData.cashwithdrawlDetails.transactionType=='BE'" button="whatsapp" [showText]="true" (click)="downloadPdf(objectData.transactionReference,'whatsapp')" [url]="pdfUrlWhatsapp" [title]="'AePS Transaction Receipt'" [description]="'Receipt'" [tags]="'AePS'">
                </share-button>

                <share-button *ngIf="objectData && objectData.transactionType=='MS'" button="whatsapp" [showText]="true" (click)="downloadPdfMS(data.receiptURl,'whatsapp')" [url]="data.receiptURl" [title]="'AePS Transaction Receipt'" [description]="'Receipt'" [tags]="'AePS'">
              </share-button>

              <share-button *ngIf="objectData && objectData.cashwithdrawlDetails.transactionType=='MS'" button="whatsapp" [showText]="true" (click)="downloadPdfMS(data.receiptURl || objectData.receiptUrl,'whatsapp')" [url]="data.receiptURl" [title]="'AePS Transaction Receipt'" [description]="'Receipt'" [tags]="'AePS'">
              </share-button>
            </div>
        </div>
    </div>

    <div *ngIf="objectData && objectData.transactionType=='MS'" class="er-receipt-ms">
        <table mat-table [dataSource]="dataSource" class="er-ms-table" style="width:100%">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> Date </th>
              <td mat-cell *matCellDef="let element" style="text-transform: capitalize;"> {{element.date}} </td>
            </ng-container>

            <ng-container matColumnDef="txnType">
              <th mat-header-cell *matHeaderCellDef> Txn type </th>
              <td mat-cell *matCellDef="let element"> {{element.txnType}} </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef class="er-ms-amount"> Amount </th>
                <td mat-cell *matCellDef="let element" class="er-ms-amount"> {{element.amount}} </td>
              </ng-container>

              <ng-container matColumnDef="narration">
                <th mat-header-cell *matHeaderCellDef> Narration </th>
                <td mat-cell *matCellDef="let element"> {{element.narration}} </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
    </div>

    <div class="er-receipt-foot">
        <button type="button" class="er-btn er-btn--ghost" (click)='cancel()'>Close</button>
    </div>
</div>
